import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './index.scss';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export const ActionPillsMenu = ({className, children}) => (
  <div className={classnames('ndx-ActionPillsMenu', className)}>
    <div className="ndx-ActionPillsMenu-buttons">{children}</div>
  </div>
);

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.any,
  label: PropTypes.string
};

ActionPillsMenu.propTypes = propTypes;

export default ActionPillsMenu;
